module.exports = __webpack_public_path__ + "img/duopingtai_yidong.9211524f.png";